import { render, staticRenderFns } from "./DropsmartCenterHeaderNavBar.vue?vue&type=template&id=63e8e3ec&scoped=true&"
import script from "./DropsmartCenterHeaderNavBar.vue?vue&type=script&lang=js&"
export * from "./DropsmartCenterHeaderNavBar.vue?vue&type=script&lang=js&"
import style0 from "./DropsmartCenterHeaderNavBar.vue?vue&type=style&index=0&id=63e8e3ec&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63e8e3ec",
  null
  
)


    import installComponents from "!/Users/leandrosehnembortolotto/Development/Dropsmart/dropsmith-frontend-v2/node_modules/bootstrap-vue-loader/lib/runtime/installComponents.js"
    import {BIconGrid3x3GapFill, BButton, BNavItem, BNavbarBrand, BCollapse, BNavbarNav, BAvatar, BIconBoxArrowRight, BNavbar, BContainer} from 'bootstrap-vue'
    installComponents(component, {BIconGrid3x3GapFill, BButton, BNavItem, BNavbarBrand, BCollapse, BNavbarNav, BAvatar, BIconBoxArrowRight, BNavbar, BContainer})
    


    import installDirectives from "!/Users/leandrosehnembortolotto/Development/Dropsmart/dropsmith-frontend-v2/node_modules/bootstrap-vue-loader/lib/runtime/installDirectives.js"
    import {VBToggle, VBTooltip} from 'bootstrap-vue'
    installDirectives(component, {'b-toggle': VBToggle, 'b-tooltip': VBTooltip})
    

export default component.exports